import { DIET_WEEK_DAYS_COUNT } from '@/const'

export const getWeekStartDayIndex = (week: number) => (week - 1) * DIET_WEEK_DAYS_COUNT
